import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VSheet, VSimpleTable, VAlert, } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosInputDemo',
    setup(__props) {
        const currencyValue = ref("");
        const phoneValue = ref("");
        return { __sfc: true, currencyValue, phoneValue, VContainer, VRow, VCol, VSheet, VSimpleTable, VAlert, CodePreview, DemoSection };
    }
});
